import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, InputNumber, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getSalaryDeductionDetails, doSalaryDeductionCreate, doSalaryDeductionUpdate 
} from "../../../../redux/salarydeduction/salaryDeductionState";
import { useForm } from 'antd/lib/form/Form';
import SelectWithOthers from "components/select/selectwithothers";
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';

const SalaryDeductionForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { sdd_start_date, sdd_end_date, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	            sdd_start_date: sdd_start_date ? dayjs(sdd_start_date, dateFormat) : null,
			    sdd_end_date: sdd_end_date ? dayjs(sdd_end_date, dateFormat) : null,
			    effective_date: [sdd_start_date ? dayjs(sdd_start_date, dateFormat) : null, sdd_end_date ? dayjs(sdd_end_date, dateFormat) : null]
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {
			const { effective_date, ...forSubmitValues } = values;			  
			forSubmitValues.sdd_start_date = effective_date[0].format('YYYY-MM-DD');
			forSubmitValues.sdd_end_date = effective_date[1].format('YYYY-MM-DD');									
			recordData.sdd_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="sdd_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-4">
        			<FormItem className="font-medium mb-2"
		            	name="sdd_employee_id"
		                label="Employee"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdd_employee_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.employeeList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdd_employee_name}</label>
		            	}	                
	            	</FormItem>  
	            	
    				   
		            <FormItem className="font-medium mb-2"
		            	name="effective_date"
		                label="Effective Date"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<RangePicker className="font-normal"
		            		format={dateFormat}
		            		style={{
						        width: 250,
						        height: 32,
						      }}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdd_start_date} to {recordData?.sdd_end_date}</label>
		            	}	                
	            	</FormItem>
	            	<FormItem className="font-medium mb-2 col-span-2"
		            	name="sdd_paycode_id"
		                label="Paycode"
		                rules={[requiredField()]}
		            >
		            	<SelectWithOthers 
		            		mode={mode}
		            		selectFieldName="sdd_paycode_id" 
		            		selectOptions={recordData?.paycodeList} 
		            		selectDisplayValue={recordData?.sdd_paycode_name}
  							othersFieldName="sdd_other_specific"
  							othersDisplayValue={recordData?.sdd_other_specific}
  							optionOthersId={[90]}
		            	/>
	            	
    				</FormItem> 		            
	            	<FormItem className="font-medium mb-2"
		            	name="sdd_total_amount"
		                label="Total Amount"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<InputNumber precision={2}
		                    id="sdd_total_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdd_total_amount}</label>
		                }
	            	</FormItem>	
	            	<FormItem className="font-medium mb-2"
		            	name="sdd_per_cutoff_amount"
		                label="Deduction Per Cut-Off"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?		            	
		            	<InputNumber precision={2}
		                    id="sdd_per_cutoff_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdd_per_cutoff_amount}</label>
		                }
	            	</FormItem>	
	            	<FormItem className="font-medium mb-2"
		            	name="sdd_type_id"
		                label="Payroll Type"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdd_type_id"
		            		allowClear={true}
						    options={recordData?.payrollTypeList}
							style={{
						        width: 150,
						      }}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdd_type_name}</label>
		            	}	                
	            	</FormItem>
	            	<FormItem className="font-medium mb-2"
		            	name="sdd_status_id"
		                label="Status"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdd_status_id"
		            		style={{
						        width: 150,
						      }}
						      options={recordData?.statusList}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.sdd_status_name}</label>
		                }
	            	</FormItem>	            	
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="sdd_notes"
		                label="Notes"
		                initialValue={recordData?.sdd_notes}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		maxLength={500}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdd_notes}</label>
		                }
	            	</FormItem>
	 			</div>	 	
	 			<CrudButtons baseRoute="/console/salary-deductions" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.salaryDeduction.salaryDeductionDetails?.data,
  	requesting: state.salaryDeduction.salaryDeductionDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getSalaryDeductionDetails(id)),
  	doCreate: (data) => dispatch(doSalaryDeductionCreate(data)),
  	doUpdate: (data) => dispatch(doSalaryDeductionUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryDeductionForm);
